// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "static/js/fa0eaf0959e923fe5dcc.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c62d5e6b73b682af6c51","154":"2345b0eedcf7bf4b0174","155":"2b71ecadbc0ef0bd1316"}[chunkId] + ".chunk.js";
};